// Persistencia del descarte de anuncios: una clave de localStorage POR
// anuncio (por id), así "no volver a mostrar" silencia solo ese aviso y
// cualquier anuncio futuro (otro id) se muestra normalmente.

const keyFor = (id) => `bt:announcement:${id}:dismissed`;

export function isAnnouncementDismissed(id) {
  try {
    return window.localStorage.getItem(keyFor(id)) === "1";
  } catch {
    return false; // localStorage bloqueado (modo privado): mostrar igual.
  }
}

export function dismissAnnouncement(id) {
  try {
    window.localStorage.setItem(keyFor(id), "1");
  } catch {
    // Sin almacenamiento no hay persistencia posible; no romper el cierre.
  }
}
